import React from 'react'
import {RiFacebookLine} from 'react-icons/ri'
import {CgInstagram} from 'react-icons/cg'
import {RiLinkedinLine} from 'react-icons/ri'
import {GrMailOption} from 'react-icons/gr'
import {Link} from 'react-router-dom'
import HelloSvg from '../images/Hello.svg'
import Hello from './Hello'


const Hero = () => {
  return (
    <section className="hero overflow-hidden bg-bgFooter px-6 ">
      <div className="
    container flex flex-col space-y-24 md:flex-row xl:space-x-12 place-content-center items-center m-auto
     md:px-18 ">
        <div className="">
            <h1 className='text-3xl mb-5 xl:mb-8 lg:text-3xl xl:text-5xl '>NAMASTE</h1>
            <hr  className="w-52 md:w-64 xl:w-96 mb-4 xl:mb-8 pb-px md:pb-px bg-blue-600 "/>
            <div className="flex flex-col">
             <h1 className='text-3xl lg:text-3xl xl:text-5xl pb-8'>
                SANTOSH KHAREL
                <span className='text-xl md:text-2xl ml-4'>here</span>
             </h1>
             <small className='text-lg lg:text-xl xL:text-2xl'>Full Stack Developer | Problem Solver | Tech Enthusiast</small>
             <div className="space-x-2 text-3xl lg:space-x-6 xl:space-x-12 flex lg:text-3xl  xl:text-4xl mr-6 -ml-8 md:ml-0 ">
             <a href='https://www.facebook.com/santosh.kharel.33/' target="_blank" rel="noreferrer" className='w-10 p-8  hover:-translate-y-2'><RiFacebookLine/></a>
             <a href='https://www.instagram.com/kharel13/' target="_blank" rel="noreferrer" className='w-10 p-8 hover:translate-y-2'><CgInstagram/></a>
             <a href='https://www.linkedin.com/in/santosh-kharel-a67a17217/'  target="_blank" rel="noreferrer" className='w-10 p-8 hover:-translate-y-2'><RiLinkedinLine/></a>
             <a href='mailto:santoshkharel9684@gmail.com' target="_blank" rel="noreferrer" className='w-10 p-8 hover:translate-y-2'><GrMailOption/></a>
             </div>
            </div>
            </div>
           <div className="">
           <div className="w-full h-full py-6">
            <Hello/>
            
            </div>
           </div>
        
    </div>
    </section>
  )
}

export default Hero